import React, { FC, memo } from "react";

import { ContactPersonDialogModal } from "@/views/Assignments/Details/components/ContactPersonDialogModal";
import { IModalIconButtonProps, ModalIconButton } from "@/views/components/Modal";

export interface IContactPersonModalButtonProps extends Omit<IModalIconButtonProps, "openable"> {}

export const ContactPersonModalButton: FC<IContactPersonModalButtonProps> = memo(({ openableProps, ...props }) => {
  return <ModalIconButton openable={ContactPersonDialogModal} openableProps={openableProps} {...props} />;
});
